var render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
      ( _obj = {}, _obj[_vm.$style.buttonRT] = _vm.isUserRT, _obj ),
      ( _obj$1 = {}, _obj$1[_vm.$style.buttonFull] = _vm.full, _obj$1 ),
      ( _obj$2 = {}, _obj$2[_vm.$style.buttonAlter] = _vm.alter, _obj$2 ),
      ( _obj$3 = {}, _obj$3[_vm.$style.buttonSeccondary] = _vm.seccondary, _obj$3 ),
      ( _obj$4 = {}, _obj$4[_vm.$style.buttonDisabled] = _vm.disabled, _obj$4 ),
      _vm.$style.button ]},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }